$(document).ready(function() {
    const BASE_URL = '/api';
    const getCSRF = () => (typeof csrf_token !== 'undefined' ? csrf_token : '');

    // --- Configuration & Selectors ---
    const SETTINGS = {
        selectors: {
            countHolder: '#js-basket-line-count',
            cartTotal: '.cart .cart_inner .bottom .cart_summary .js-basket_sub_total',
            cartContainer: '.cart .cart_inner .products'
        }
    };

    const Utils = {
        formatMoney: (num) => num.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    }

    // --- REUSABLE HELPERS ---
    const apiCall = (url, method = 'GET', data = null) => {
        return $.ajax({
            url: url.startsWith('http') ? url : BASE_URL + url,
            method: method,
            dataType: 'json',
            contentType: 'application/json',
            headers: {
                'Accept': 'application/json',
                'X-CSRFToken': getCSRF()
            },
            data: data ? JSON.stringify(data) : (method === 'POST' ? '' : null)
        });
    };

    const toggleSelection = ($el, $container, btnText = 'Selected') => {
        const $option = $el.closest('.option');
        $container.find('.option').removeClass('selected').find('a span, .js-select-this-slot').text('Select');
        $option.addClass('selected');
        if ($el.find('span').length) $el.find('span').text(btnText);
        else $el.text(btnText);
    };

    const updateSubstitutionUI = (val) => {
        if (!val) return;
        const $btn = $(`.js-select-sub[data-card-sub="${val}"]`);
        toggleSelection($btn, $('.sub_options'));
    };

    const updateGlobalTotals = (totalPrice, uniqueLinesCount) => {
        // Update Count (Unique items / num_lines)
        const $count = $(SETTINGS.selectors.countHolder);
        $count.html(uniqueLinesCount);
    
        // Update Total Price (Directly from server)
        const $total = $(SETTINGS.selectors.cartTotal);
        $total.html(Utils.formatMoney(totalPrice));
    };

    const refreshSummaryTotals = () => {
        apiCall('/checkout/summary/').done(data => {
            const $summary = $('.summary_breakdown');
            const { basket, points, points_value } = data;
            const currency = $summary.find('.currency').first().text();
    
            // 1. Update Standard Fields (Total and Shipping)
            $summary.find('.sub_total .cost').text(parseFloat(basket.total_incl_tax_excl_discounts).toFixed(2));
            $summary.find('.total .cost').text(parseFloat(basket.order_total).toFixed(2));
    
            const $deliveryRow = $summary.find('.delivery_fee');
            if (basket.shipping_charge > 0) {
                $deliveryRow.find('.cost').text(parseFloat(basket.shipping_charge).toFixed(2));
                $deliveryRow.find('.currency').text(basket.currency).show();
            } else {
                $deliveryRow.find('.cost').text('FREE');
                $deliveryRow.find('.currency').hide().text('');
            }
    
            /**
             * Helper to update or create discount rows
             * @param {string} className - Unique class for the row
             * @param {string} label - Text to display
             * @param {number} value - Discount amount
             * @param {boolean} condition - Whether to show the row
             */
            const updateDiscountRow = (className, label, value, condition) => {
                let $row = $summary.find(`.${className}`);
                if (condition && value > 0) {
                    const formattedVal = parseFloat(value).toFixed(2);
                    if ($row.length) {
                        $row.find('.cost').text(formattedVal);
                    } else {
                        const html = `
                            <div class="summary_row ${className} discounted">
                                <div class="left"><span>${label}</span></div>
                                <div class="right">
                                    <p><span class="currency">${currency}</span> <span class="cost">${formattedVal}</span></p>
                                </div>
                            </div>`;
                        $(html).insertBefore($deliveryRow);
                    }
                } else {
                    $row.remove();
                }
            };
    
            // 2. Handle Discount Rows via Helper
            updateDiscountRow(
                'points_discount', 
                'Points discount', 
                points_value, 
                (points > 0 || points_value)
            );
    
            updateDiscountRow(
                'voucher_discounts', 
                'Voucher discount', // Fixed label from "Points discount"
                basket.total_discount, 
                (basket.vouchers?.[0]?.id > 0 && basket.total_discount > 0)
            );
        });
    };

    // --- 1. PRODUCT LOGIC ---

    $('.js-show-all-products').on('click', function(e) {
        e.preventDefault();
        $('.order_details .card .products').addClass('show-all');
        $(this).parent().remove();
    });

    // --- 2. CHECKOUT INITIALIZATION ---

    if ($('.checkout_page').length) {
        // Fetch Main Summary
        apiCall('/checkout/summary/').done(data => {
            updateSubstitutionUI(data.substitution);
            $('input[name="loyalty_points"]').val(data.points);
            
            if (Number(data.points) > 0) $('.js-reset-loyalty-points').removeClass('disabled');

            // Delivery Method UI
            if (data.express) {
                toggleSelection($('.js-select-express-delivery'), $('.card_options.time'));
            }else{                
                toggleSelection($('.js-select-standard-delivery'), $('.card_options.time'));
            }
            //  else if (data.timeslot?.id > 0) {                
                // const $opt = $('.option.scheduled').addClass('selected');
                // $opt.find('.js-switch-slots span').text('Change');
                // $opt.find('.info p').html(`Selected Slot: <span class="js-first-availble-slot">${data.timeslot.day}, ${data.timeslot.slot}</span>`);
            // }

            // Payment Method UI
            if (data.payment_method === 'Card') {
                toggleSelection($('.card_on_delivery .js-select-card-online'), $('.payment'));
            } else if (data.payment_method === 'online' && data.card?.id > 0) {
                const $target = $(`.payment .option[data-card-id="${data.card.id}"] .js-select-card`);
                toggleSelection($target, $('.payment'));
            } else {
                // Fetch Default Card if nothing selected
                // apiCall('/cards/bankcards/default/card').done(res => {
                //     if (res?.id) toggleSelection($(`.payment .js-select-card[data-card-id="${res.id}"]`), $('.payment'));
                // });
            }

            
            //Vouchers
            const hasVouchers = data.basket.vouchers && data.basket.vouchers[0]?.id > 0
            const voucher = data.basket?.vouchers[0]?.code;
            const voucher_id = data.basket?.vouchers[0]?.id;
            if(hasVouchers){
                $('#coupon-code').find('input[name="coupon"]').val(voucher);
                $('#coupon-code').find('button').removeClass('js-apply-coupon').addClass('js-remove-coupon').attr('data-voucher-id', voucher_id).find('span').text('Remove');
            }
        });

        // Fetch Loyalty Info
        if ($('.loaylty_use').length) {
            apiCall('/checkout/points/available').done(data => {
                if(data.validation_error && data.validation_error.length > 0){
                    $('.loaylty_use').find('.notes').html(`<p>${data.validation_error}</p>`);
                    $('.js-use-loyalty-points').addClass('disabled');
                }else{
                    $('.min_redeem').text(data.min_redeemable);
                    $('.max_redeem').text(data.max_redeemable);
                }
            });
        }
    }

    // --- 3. TIMESLOT LOGIC ---

    // if ($('.js-fetch-timeslots').length) {
    //     // Get Current Slot
    //     if (signed_in){
    //         apiCall('/checkout/timeslots/get/').done(res => {
    //             const text = res?.id ? `${res.day}, ${res.slot}` : 'Choose a slot';
    //             $('.js-update-current-slot').html(res?.id ? `Delivery by ${text}` : 'Choose a delivery slot');
    //             $('.js-first-availble-slot').html(text);
    //         });

    //         // Get All Slots & Render
    //         apiCall('/checkout/timeslots/').done(response => {
    //             const $wrapper = $('.timeslots_list .days .swiper-wrapper').empty();
    //             const $list = $('.timeslots_list');
    //             const today = new Date().toISOString().split('T')[0];

    //             response.forEach((dayObj, i) => {
    //                 const isToday = dayObj.date === today;
    //                 const dayLabel = isToday ? "Today" : dayObj.day_name.charAt(0).toUpperCase() + dayObj.day_name.slice(1);
                    
    //                 $wrapper.append(`
    //                     <div class="swiper-slide ${i === 0 ? 'active-day' : ''} js-day-slide" data-target="day_${dayObj.date}">
    //                         <span>${dayLabel}</span> <span>${dayObj.day_abbr}</span>
    //                     </div>`);

    //                 let slotsHtml = `<div class="timeSlots" data-date-target="day_${dayObj.date}" style="display: ${i === 0 ? 'block' : 'none'}">`;
    //                 dayObj.slots.forEach(s => {
    //                     slotsHtml += `
    //                         <div class="slot ${s.available ? '' : 'not-available'}" data-slot-id="${s.pk}" data-date="${dayObj.date}" data-day="${dayLabel}" data-timeframe="${s.timeframe}">
    //                             <div class="left"><span>${s.timeframe}</span></div>
    //                             <div class="right"><span class="js-select-this-slot">${s.available ? 'Select' : 'Unavailable'}</span></div>
    //                         </div>`;
    //                 });
    //                 $list.append(slotsHtml + '</div>');
    //             });

    //             new Swiper('.timeslots_list .days .swiper', { slidesPerView: 'auto', spaceBetween: 10, observer: true });
    //         });
    //     }
    // }

    // --- 4. EVENT DELEGATION (Global Handlers) ---

    // $(document).on('click', '.js-day-slide', function() {
    //     const $this = $(this);
    //     const targetSelector = $(this).data('target');

    //     $this.addClass('active-day').siblings().removeClass('active-day');

    //     // 2. Hide all timeslot containers
    //     $('.timeSlots').hide();
    //     $(`.timeSlots[data-date-target="${targetSelector}"]`).fadeIn(200);
    // }).on('click', '.js-select-this-slot', function(e) {
    //     const $slot = $(this).closest('.slot');
    //     if ($slot.hasClass('not-available')) return;

    //     apiCall(`/checkout/timeslots/set/?slot_id=${$slot.data('slot-id')}&date=${$slot.data('date')}`, 'POST').done(() => {
    //         $('.js-update-current-slot').html(`Delivery by ${$slot.data('day')}, ${$slot.data('timeframe')}`);
    //         $('.js-first-availble-slot').text(`${$slot.data('day')}, ${$slot.data('timeframe')}`);
    //         $('.checkout_page .timeslots_list').slideUp();
    //         $('.cart .timeslots_list').removeClass('open');
    //         $('.js-switch-slots span').text("Change");

    //         $('.js-select-express-delivery span').text('Select');
    //         $('.option.express').removeClass('selected');
    //         $('.option.scheduled').addClass('selected');

    //         apiCall('/checkout/express/set/?express=false', 'POST').done(data => {
    //             refreshSummaryTotals();
                    
    //             showToast(`<h4 class="red">Delivery Updated</h4><p>Scheduled shipping selected.</p>`);
    //         });


    //     });
    // })
    $(document).on('click', '.js-select-address', function(e) {
        e.preventDefault();
        const $btn = $(this);
        const id = $btn.data('address-id');

        $('.address_switcher_info').addClass('open');
        $('body').addClass('locked');
        $('.js-confirm-change-address-checkout').attr('data-address-id', id).removeClass('disabled');
        
    }).on('click', '.js-confirm-change-address-checkout', function(e) {
        e.preventDefault();
        const id = $(this).data('address-id');
        $(this).addClass('disabled');
        const $source = $(`.js-select-address[data-address-id="${id}"]`).closest('.listed_address');

        apiCall(`/checkout/address/?address_id=${id}`, 'POST').done(() => {
            showToast(`<h4 class="red">Delivery Address</h4><p>Changed successfully!</p>`);
            const $target = $('.default_address').attr('data-address-id', id);
            $target.find('h4').html($source.find('h4').html());
            $target.find('p').not('.note').html($source.find('p').not('.note').html());
            $target.find('.note').remove();
            if ($source.find('.note').length) $target.append(`<p class="note">${$source.find('.note').html()}</p>`);
            $('.address_list').slideUp();
            $('.js-display-address-list').show();

            $('.address_switcher_info').removeClass('open');
            $('body').removeClass('locked');
        });
    }).on('click', '.js-checkout-add-new-address', function(e) {
        e.preventDefault();
        const address_url = $(this).attr('href');
        $('.address_switcher_info').addClass('open');
        $('body').addClass('locked');
        $('.js-confirm-change-address-checkout').attr('data-url', address_url).addClass('js-confirm-change-address').removeClass('js-confirm-change-address-checkout disabled');        
    }).on('click', '.js-remove-card', function() {
        const $card = $(this).closest('.card');
        apiCall(`/cards/bankcards/${$(this).data('card-id')}`, 'DELETE').done(() => {
            $card.fadeOut(300, () => $card.remove());
        });
    }).on('click', '.js-select-card', function(e) {
        const $btn = $(this);
        apiCall(`/checkout/card/?card_id=${$btn.data('card-id')}`, 'POST').done(() => {
            toggleSelection($btn, $btn.closest('.card_options'));
            apiCall(`/checkout/payment/set/?method=Onlline`, 'POST');
        });
    }).on('click', '.js-select-card-online', function(e) {
        const $btn = $(this);
        apiCall(`/checkout/payment/set/?method=Card`, 'POST').done(() => {
            toggleSelection($btn, $btn.closest('.card_options'));
        });
    }).on('click', '.js-open-card-form', function(e) {
        e.preventDefault();
        const $btn = $(this);
        const $platform = $btn.data('platform');
        $btn.prop('disabled', true); // Prevent double-clicks

        apiCall('/cards/tokenize', 'POST', { "platform": $platform })
            .done(response => {
                if (response.checkout_url) {
                    window.location.href = response.checkout_url;
                } else {
                    $btn.prop('disabled', false);
                }
            })
            .fail(() => $btn.prop('disabled', false));

    }).on('click', '.js-use-loyalty-points', function() {
        const val = $('input[name="loyalty_points"]').val();
        apiCall(`/checkout/points/set/?points=${val}`, 'POST').done(res => {
            if (res.success) {
                showToast(`<h4 class="red">Loyalty</h4><p>Applied!</p>`);
                refreshSummaryTotals();
                $('.js-reset-loyalty-points').removeClass('disabled');
            } else {
                showToast(`<h4 class="red">Error</h4><p>${res.error}</p>`);
            }
        });
    }).on('click', '.js-reset-loyalty-points', function() {
        const val = $('input[name="loyalty_points"]').val();
        apiCall(`/checkout/points/reset/`, 'POST').done(res => {
            if (res.success) {
                showToast(`<h4 class="red">Loyalty</h4><p>Points reset!</p>`);
                refreshSummaryTotals();
                $('input[name="loyalty_points"]').val('');
                $(this).addClass('disabled');
            } else {
                showToast(`<h4 class="red">Error</h4><p>${res.error}</p>`);
            }
        });
    }).on('click', '.js-open-timeslots', function(e) { 
        e.preventDefault();
        
        const $cartList = $('.cart .timeslots_list');
        $cartList.css('display', '').addClass('open'); 
        
        // 3. Force Swiper to recalculate layout now that it's visible
        setTimeout(() => {
            if (typeof daysSwiper !== 'undefined') {
                Array.isArray(daysSwiper) ? daysSwiper.forEach(s => s.update()) : daysSwiper.update();
            }
        }, 100); 
    
    // Close Timeslots in Cart
    }).on('click', '.js-close-cart-timeslots', function(e) { 
        e.preventDefault();
        // In your original logic, the cart uses a class-based toggle
        $('.cart .timeslots_list').removeClass('open');

    // Select the Express checkout
    }).on('click', '.js-select-express-delivery', function(e) {
        e.preventDefault();     
        const $button = $(this).find('span');
        const $parent = $(this).closest('.option');   
        const $sibling = $('.js-select-standard-delivery span'); 
        const $siblingOption = $('.option.standard ');
    
        // 3. AJAX: Notify the server to update the basket totals
        apiCall('/checkout/express/set/?express=true', 'POST').done(data => {
            $sibling.text('Select');
            $siblingOption.removeClass('selected');

            $parent.addClass('selected');
            $button.text('Selected');
            refreshSummaryTotals();
                
            showToast(`<h4 class="red">Delivery Updated</h4><p>Express shipping selected.</p>`);
        });
    // Select the Standard checkout
    }).on('click', '.js-select-standard-delivery', function(e) {
        e.preventDefault();     
        const $button = $(this).find('span');
        const $parent = $(this).closest('.option');   
        const $sibling = $('.js-select-express-delivery span'); 
        const $siblingOption = $('.option.express ');
    
        // 3. AJAX: Notify the server to update the basket totals
        apiCall('/checkout/express/set/?express=false', 'POST').done(data => {
            $sibling.text('Select');
            $siblingOption.removeClass('selected');

            $parent.addClass('selected');
            $button.text('Selected');
            refreshSummaryTotals();
                
            showToast(`<h4 class="red">Delivery Updated</h4><p>Standard shipping selected.</p>`);
        });
    }).on('click', '.js-select-sub', function(e) {
        e.preventDefault();
        const val = $(this).data('card-sub');
        apiCall('/checkout/substitution/set/?substitution=' + encodeURIComponent(val), 'POST').done(() => {
            updateSubstitutionUI(val);
            showToast(`<h4 class="red">Success</h4><p>Substitution updated.</p>`);
        });
    }).on('click', '.js-apply-coupon', function(e){
        e.preventDefault();
        const $btn = $(this);
        const $form = $('#coupon-code');
        // if (!validateForm($form)) return;

        const coupon = $form.find('input[name="coupon"]').val();

        $.ajax({
            url: `/api/basket/vouchers/?code=${coupon}`,
            type: 'POST',
            headers: {'accept': 'application/json' },            
            success: function(data) {   
                refreshSummaryTotals();
                updateGlobalTotals(data.basket.order_total, data.basket.num_lines);
                $btn.removeClass('js-apply-coupon').addClass('js-remove-coupon').attr('data-voucher-id', data.basket?.vouchers[0]?.id).find('span').text('Remove');
                if (data.message){
                    showToast(`<h4 class="red">Coupon Applied</h4><p>${data.message}</p>`);
                }else{
                    showToast(`<h4 class="red">Coupon Applied</h4><p>Successfully!</p>`);
                }           
            },
            error: function(xhr) {
                showToast(`<h4 class="red">Coupon Error</h4><p>${xhr.responseJSON.message}</p>`);
            }
        });
    }).on('click', '.js-remove-coupon', function(e){
        e.preventDefault();
        const $btn = $(this);
        const $form = $('#coupon-code');
        // if (!validateForm($form)) return;

        const voucher_id = $(this).data('voucher-id');

        $.ajax({
            url: `/api/basket/vouchers/${voucher_id}`,
            type: 'DELETE',
            headers: {'accept': 'application/json' },            
            success: function(data) {   
                refreshSummaryTotals();
                updateGlobalTotals(data.basket.order_total, data.basket.num_lines);
                $btn.removeClass('js-remove-coupon').addClass('js-apply-coupon').attr('data-voucher-id', '').find('span').text('Apply');
                $form[0].reset();
                if (data.message){
                    showToast(`<h4 class="red">Coupon Removed</h4><p>${data.message}</p>`);
                } else{
                    showToast(`<h4 class="red">Coupon Removed</h4><p>Successfully!</p>`);
                }            
            },
            error: function(xhr) {
                showToast(`<h4 class="red">Coupon Error</h4><p>${xhr.responseJSON.message}</p>`);
            }
        });
    });

    // Simple Toggles
    $('.js-display-address-list').on('click', function() { $(this).hide(); $('.address_list').slideDown(); });
    // $('.js-switch-slots').on('click', () => $('.checkout_page .timeslots_list').slideToggle(300));
    $('.js-edit-loyalty-points').on('click', () => $('.loaylty_use').slideDown());
    

    $(document).on('click', '.js-validate-checkout', function(e) {
        e.preventDefault();
        const $button = $(this);
        const $form = $(this).closest('form#place_order_form');
    
        apiCall('/checkout/summary/').done(data => {    
            let missingFields = [];
    
            // 1. Check if address has id
            if (!data.address || !data.address.id) {
                missingFields.push("Shipping Address");
            }
    
            // 2. Check if card has id (only if payment_method is online)
            // Note: You can remove the payment_method check if it's always required
            if (data.payment_method === 'online'){
                if (!data.card || !data.card.id) {
                    missingFields.push("Payment Card");
                }
            }
    
            // 3. Check if substitution has a value
            if (!data.substitution || data.substitution.trim() === "") {
                missingFields.push("Substitution Preference");
            }
    
            // 4. Check timeslot if express is false
            // if (data.express === false) {
            //     if (!data.timeslot || !data.timeslot.id) {
            //         missingFields.push("Delivery Timeslot");
            //     }
            // }
    
            // Final Validation Check
            if (missingFields.length > 0) {
                const listString = missingFields.join(', ');
                showToast(`<h4 class="red">Checkout failed!</h4><p>Unselected: ${listString}</p>`);
            } else {
                $button.addClass('disabled');
                $form[0].submit();
            }
        });
    });

});
